import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';
import { FilterArquivo } from '../_models/filter/FilterArquivo';
import { FilterArquivoHeader } from '../_models/filter/FilterArquivoHeader';

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

@Injectable({ providedIn: 'root' })
export class ArquivoService {

  constructor(private http: HttpClient, private authenticationService: AuthenticationService) { }

  getAll() {
    const headers = new HttpHeaders()
    .set('Authorization', 'Bearer ' + this.authenticationService.atualUserTokenValue)
    .set('Content-Type', 'application/json');
    return this.http.get<any>(`${environment.authorizedUrls.bsCobrancaUrl}/arquivo/listarArquivos`, {headers});
  }

  getAllPorEmpresa(filterArquivoHeader: FilterArquivoHeader) {
    const headers = new HttpHeaders()
    .set('Authorization', 'Bearer ' + this.authenticationService.atualUserTokenValue)
    .set('Content-Type', 'application/json');
    return this.http.post<any>(`${environment.authorizedUrls.bsCobrancaUrl}/arquivo/listarArquivosPorEmpresa/`, filterArquivoHeader, {headers});
  }

  getAllPorParametros(filterArquivoHeader: FilterArquivoHeader) {
    const headers = new HttpHeaders()
    .set('Authorization', 'Bearer ' + this.authenticationService.atualUserTokenValue)
    .set('Content-Type', 'application/json');
    return this.http.post<any>(`${environment.authorizedUrls.bsCobrancaUrl}/arquivo/listarArquivosPorParametros/`, filterArquivoHeader, {headers});
  }

  exportarRelatorioArquivos(filterArquivo: FilterArquivo){
    return this.http.post(`${environment.authorizedUrls.bsCobrancaUrl}/arquivo/exportarArquivos`, {
      filterArquivo
    }, {responseType: 'blob' as 'json'})
  }

}
